import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getScenarioCostExportStatus = api(async function scenarioCostExportStatus({ jobId }) {
    return query(
        gql`
            query GetScenarioCostExportStatus($jobId: String!) {
                scenarioCostExportStatus(jobId: $jobId) {
                    jobId
                    status
                    attempts
                    error
                    url
                    filename
                    expires
                }
            }
        `,
        { jobId },
        // network-only: this is polled while the job runs; the cache-first default
        // would freeze the first status forever.
        { returns: "scenarioCostExportStatus", fetchPolicy: "network-only" }
    )
})
